module.exports = __webpack_public_path__ + "img/livingTogether.svg";